'use client';

import { useEffect, useState } from 'react';

const DELAY = 500;

export function usePageLoaded() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, DELAY);

    return () => clearTimeout(timer);
  }, []);

  return isLoaded;
}
